import { NotificationManager } from 'react-notifications';

export default (text: string, notification: string) => {
  navigator.clipboard.writeText(text);
  NotificationManager.info(notification, null, 2000);
};
